// @ts-nocheck

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchSpecialOffersTable, fetchSpecialOffers, fetchSpecialOfferById, addSpecialOffer, updateSpecialOffer, removeSpecialOffer } from "../../api/specialOffersApi";

// Async thunks for special offer operations

export const getSpecialOffers = createAsyncThunk(
  "specialOffer/getSpecialOffers",
  async ({ page, limit }: { page: number; limit: number }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchSpecialOffersTable(page, limit);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getSpecialOfferById = createAsyncThunk(
  "specialOffer/getSpecialOfferById",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await fetchSpecialOfferById(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const createSpecialOffer = createAsyncThunk(
  "specialOffer/createSpecialOffer",
  async (newOffer: { name: string; description: string; price: number; photo?: string }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await addSpecialOffer(newOffer);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const editSpecialOffer = createAsyncThunk(
  "specialOffer/editSpecialOffer",
  async ({ id, updatedOffer }: { id: string; updatedOffer: { name: string; description: string; price: number; photo?: string } }, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await updateSpecialOffer(id, updatedOffer);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteSpecialOffer = createAsyncThunk(
  "specialOffer/deleteSpecialOffer",
  async (id: string, { dispatch, rejectWithValue }) => {
    dispatch(resetStatus());

    try {
      return await removeSpecialOffer(id);
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Special Offer Slice

const specialOfferSlice = createSlice({
  name: "specialOffer",
  initialState: {
    specialOffers: [] as any[],
    specialOffer: null as any | null,
    status: null as boolean | null,
    msg: "",
    error: null as string | null,
  },
  reducers: {
    resetStatus(state) {
      state.status = null;
      state.msg = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all special offers
      .addCase(getSpecialOffers.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.status = true;
        state.specialOffers = action.payload;
      })
      .addCase(getSpecialOffers.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      
      // Get special offer by ID
      .addCase(getSpecialOfferById.fulfilled, (state, action: PayloadAction<any>) => {
        state.status = true;
        state.specialOffer = action.payload;
      })
      .addCase(getSpecialOfferById.rejected, (state, action) => {
        state.status = false;
        state.error = action.payload as string;
      })
      
      // Create special offer
      .addCase(createSpecialOffer.fulfilled, (state, action: PayloadAction<any>) => {
        if (Array.isArray(action.payload)) {
          state.specialOffers.push(action.payload);
          state.status = true;
          state.msg = "Special offer created successfully.";
        } else {
          console.log('special offer not an array');
        }
      })
      
      // Edit special offer
      .addCase(editSpecialOffer.fulfilled, (state, action: PayloadAction<any>) => {
        const { id, data } = action.payload;
        if (Array.isArray(state.specialOffers)) {
          const index = state.specialOffers.findIndex((offer) => offer.id === id);
          if (index !== -1) {
            state.specialOffers[index] = data;
          }
          state.status = true;
          state.msg = "Special offer updated successfully.";
        } else {
          console.log('special offer not an array');
        }
      })
      
      // Delete special offer
      .addCase(deleteSpecialOffer.fulfilled, (state, action: PayloadAction<string>) => {
        if (Array.isArray(state.specialOffers)) {
          state.specialOffers = state.specialOffers.filter((offer) => offer.id !== action.payload);
          state.status = true;
          state.msg = "Special offer deleted successfully.";
        } else {
          console.log('special offer not an array');
        }
      });
  },
});

export const { resetStatus } = specialOfferSlice.actions;
export default specialOfferSlice.reducer;
